import { round, roundCents } from '@/utils/money'
import type { CalculatorContext } from '@/types/calculator'
import type { MarkupProfitInputs, MarkupProfitResult } from './types'

export function calculateMarkupProfit(
  inputs: MarkupProfitInputs,
  _context: CalculatorContext
): MarkupProfitResult {
  const revenue = inputs.sellingPricePerUnit * inputs.quantity
  const totalCost = inputs.costPerUnit * inputs.quantity + inputs.overhead
  const grossProfit = revenue - inputs.costPerUnit * inputs.quantity
  const netProfit = revenue - totalCost

  const markup =
    inputs.costPerUnit > 0
      ? (inputs.sellingPricePerUnit - inputs.costPerUnit) / inputs.costPerUnit
      : 0
  const margin = inputs.sellingPricePerUnit > 0 ? grossProfit / revenue : 0

  const contributionPerUnit = inputs.sellingPricePerUnit - inputs.costPerUnit
  const breakEvenUnits =
    contributionPerUnit > 0 && inputs.overhead > 0 ? inputs.overhead / contributionPerUnit : 0

  // Recommend a price for a target 30% margin
  const targetMargin = 0.3
  const recommendedPriceForMargin =
    inputs.costPerUnit > 0 ? inputs.costPerUnit / (1 - targetMargin) : 0

  return {
    revenue: roundCents(revenue),
    totalCost: roundCents(totalCost),
    grossProfit: roundCents(grossProfit),
    netProfit: roundCents(netProfit),
    markup: round(markup, 4),
    margin: round(margin, 4),
    breakEvenUnits: roundCents(breakEvenUnits),
    recommendedPriceForMargin: roundCents(recommendedPriceForMargin),
  }
}
